import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { loyalty } from './reducer';

const initLoyaltyState = {
  exchangeModalOpened: false,
  addFundsModalOpened: false,
  showRewardInfo: false,
  mainStakingWallet: null,
  wallets: [],
  cashbackData: {},
};

export const LoyaltyContext = createContext(initLoyaltyState);

export const LoyaltyProvider = ({ children }) => {
  const [state, dispatch] = useReducer(loyalty?.LoyaltyReducer, initLoyaltyState);

  const boundActions = {};
  // eslint-disable-next-line guard-for-in, guard-for-in
  for (const key in loyalty?.actions) {
    boundActions[key] = loyalty.actions[key](dispatch);
  }

  return (
    <LoyaltyContext.Provider value={{ state, ...boundActions }}>{children}</LoyaltyContext.Provider>
  );
};

LoyaltyProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
